import { salesDataSourceSaveRejectionReason } from 'commons/service/bank/salesData'
import { SalesDataSourceSaveRejectionReasonPayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataSourceSaveRejectionReason: WriteHook<SalesDataSourceSaveRejectionReasonPayload, void> = (
  opts
) => useMutationManager<SalesDataSourceSaveRejectionReasonPayload, void>(salesDataSourceSaveRejectionReason, opts)
